import { lazy } from "react";
import {enumPermisosParametrizacionDatafono} from "./enumPermisosParametrizacionDatafono";
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));
const ParametrizacionDatafono = lazy(() =>
    import("./Views/ParametrizacionDatafono/ParametrizacionDatafono")
);

export const rutasParametrizacionDatafono = {
  link: "/parametrizacion-datafono",
  label: <AppIcons Logo={"RECAUDO"} name="Parametrización Datáfono" />,
  component: ParametrizacionDatafono,
  permission: [enumPermisosParametrizacionDatafono.PARAMETRIZACION_DATAFONO],
  subRoutes: [],
};

export default rutasParametrizacionDatafono;
